import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const PageVisitTracker = () => {

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const sessionKey = 'page_visit_tracked';
        const sessionTimeout = 30 * 60 * 1000;
        
        const lastVisit = sessionStorage.getItem(sessionKey);
        const now = Date.now();
        
        if (!lastVisit || (now - parseInt(lastVisit)) > sessionTimeout) {
          await supabase.functions.invoke('track-visit', {
            body: {
              page_path: '/',
              user_agent: navigator.userAgent,
              referrer: document.referrer || null
            }
          });
          
          sessionStorage.setItem(sessionKey, now.toString());
        }
      } catch (error) {
        console.error('Failed to track page visit:', error);
      }
    };

    trackVisit();
  }, []);

  return null;
};

export default PageVisitTracker;
